import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import { locations } from '../data/locations';

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About */}
          <div>
            <Link to="/" className="flex items-center mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_better-website-5/artifacts/01cb8dc0_Screenshot%202026-01-10%20185208.png" 
                alt="Millie's Motorhome Hire" 
                className="h-20 w-auto object-contain"
              />
            </Link>
            <p className="text-sm text-slate-400 mb-4">
              Family-run motorhome hire business in Suffolk, offering luxury vehicles for your UK and European adventures.
            </p>
            <div className="flex gap-3">
              <a href="https://www.facebook.com/100432836071005" target="_blank" rel="noopener noreferrer" className="bg-slate-800 p-2 rounded-full hover:bg-blue-600 transition-colors">
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                </svg>
              </a>
              <a href="https://www.instagram.com/millies_motorhome_hire/" target="_blank" rel="noopener noreferrer" className="bg-slate-800 p-2 rounded-full hover:bg-pink-600 transition-colors">
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                </svg>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="text-slate-400 hover:text-white transition-colors">Home</Link></li>
              <li><Link to="/motorhomes" className="text-slate-400 hover:text-white transition-colors">Motorhomes for Hire</Link></li>
              <li><Link to="/servicing" className="text-slate-400 hover:text-white transition-colors">Mobile Servicing</Link></li>
              <li><Link to="/reviews" className="text-slate-400 hover:text-white transition-colors">Customer Reviews</Link></li>
              <li><Link to="/how-it-works" className="text-slate-400 hover:text-white transition-colors">How it Works</Link></li>
              <li><Link to="/gallery" className="text-slate-400 hover:text-white transition-colors">Gallery</Link></li>
              <li><Link to="/faqs" className="text-slate-400 hover:text-white transition-colors">FAQs</Link></li>
              <li><Link to="/on-the-day" className="text-slate-400 hover:text-white transition-colors">On the Day</Link></li>
              <li><Link to="/gift-vouchers" className="text-slate-400 hover:text-white transition-colors">Gift Vouchers</Link></li>
              <li><Link to="/roller-team-parts" className="text-slate-400 hover:text-white transition-colors">Roller Team Parts & Spares</Link></li>
              <li><Link to="/guides" className="text-slate-400 hover:text-white transition-colors">Touring Guides</Link></li>
              <li><Link to="/terms-and-conditions" className="text-slate-400 hover:text-white transition-colors">Terms & Conditions</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Contact Us</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <MapPin className="h-5 w-5 text-blue-400 flex-shrink-0 mt-0.5" />
                <span className="text-slate-400">
                  <span className="block text-xs uppercase tracking-wide text-slate-500 mb-0.5">Collection &amp; drop-off address</span>
                  Clay Hill Farm, Clay Hill Lane<br />
                  Wattisham, Ipswich, Suffolk<br />
                  <span className="text-white font-bold">IP7 7JS</span>, England
                </span>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="h-5 w-5 text-blue-400 flex-shrink-0" />
                <a href="tel:07527006966" className="text-slate-400 hover:text-white transition-colors">
                  07527 006966
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Mail className="h-5 w-5 text-blue-400 flex-shrink-0" />
                <a href="mailto:milliesmotorhomehire@gmail.com" className="text-slate-400 hover:text-white transition-colors break-all">
                  milliesmotorhomehire@gmail.com
                </a>
              </li>
            </ul>
          </div>

          {/* Opening Hours & Collection Times */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Hours & Collection Times</h3>
            <div className="flex items-start gap-2 text-sm mb-4">
              <Clock className="h-5 w-5 text-blue-400 flex-shrink-0 mt-0.5" />
              <div className="text-slate-400">
                <p>Monday - Sunday</p>
                <p className="font-semibold text-white">08:00 - 18:00</p>
              </div>
            </div>
            <div className="bg-slate-800 rounded-lg p-4 text-sm mb-4">
              <p className="text-green-400 font-semibold mb-2">Standard Times (FREE)</p>
              <div className="space-y-1 text-slate-300">
                <p><span className="text-green-400">Collection:</span> 3:00 PM</p>
                <p><span className="text-amber-400">Drop-off:</span> 11:00 AM</p>
              </div>
              <p className="text-slate-500 text-xs mt-2">
                Extend times via extras during booking
              </p>
            </div>
            <div className="bg-slate-800 rounded-lg p-4 text-sm mb-4">
              <p className="text-amber-400 font-semibold mb-2">Pets Welcome!</p>
              <div className="space-y-1 text-slate-300">
                <p>1 pet: <span className="text-amber-400 font-semibold">£20</span></p>
                <p>2 pets: <span className="text-amber-400 font-semibold">£40</span></p>
              </div>
              <p className="text-slate-500 text-xs mt-2">
                Select via extras during booking
              </p>
            </div>
            <div className="bg-slate-800 rounded-lg p-4 text-sm">
              <p className="text-blue-400 font-semibold mb-2">Official Recommendation</p>
              <p className="text-slate-400 mb-3">
                Camping & Caravanning Club approved supplier - get site discounts when you hire from us
              </p>
              <img 
                src="https://customer-assets.emergentagent.com/job_better-website-5/artifacts/sseihcg6_Screenshot%202026-01-11%20103414.png"
                alt="The Camping and Caravanning Club"
                className="max-w-[180px]"
              />
            </div>
          </div>
        </div>

        {/* Areas we cover */}
        <div className="mt-12 pt-8 border-t border-slate-800" data-testid="footer-areas">
          <h3 className="font-semibold text-lg mb-3">Motorhome Hire Across Suffolk & Essex</h3>
          <p className="text-sm text-slate-400 mb-4">Based at Wattisham in central Suffolk - an easy drive from across both counties, with free parking for your car while you're away.</p>
          <div className="flex flex-wrap gap-2">
            {locations.map((l) => (
              <Link key={l.slug} to={`/motorhome-hire/${l.slug}`} className="text-xs bg-slate-800 hover:bg-blue-600 text-slate-300 hover:text-white px-3 py-1.5 rounded-full transition-colors">
                Motorhome hire {l.name}
              </Link>
            ))}
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 pt-8 border-t border-slate-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-slate-400">
            <p>© {new Date().getFullYear()} Millie's Motorhome Hire. All rights reserved.</p>
            <div className="flex gap-6">
              <Link to="/terms-and-conditions" className="hover:text-white transition-colors">Privacy & Terms</Link>
              <Link to="/roller-team-parts" className="hover:text-white transition-colors">Roller Team Spares</Link>
            </div>
          </div>
          <div className="mt-4 text-center">
            <p className="text-xs text-slate-500">
              Recommended by the Camping and Caravanning Club
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
